module.exports = __webpack_public_path__ + "static/media/social-row.282010ec.jpg";